import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

const PARAM = 'games'

/**
 * Whether the games room is open, and at which table, kept in the address bar: a link to a table
 * opens it, and the back button closes it. An empty value is the lobby.
 */
export function useGamesDialog() {
  const [params, setParams] = useSearchParams()
  const raw = params.get(PARAM)
  const set = useCallback(
    (value: string | null) =>
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          if (value === null) next.delete(PARAM)
          else next.set(PARAM, value)
          return next
        },
        { replace: false },
      ),
    [setParams],
  )
  return {
    open: raw !== null,
    host: raw ? raw : null,
    openLobby: useCallback(() => set(''), [set]),
    openTable: useCallback((host: string) => set(host), [set]),
    close: useCallback(() => set(null), [set]),
  }
}
